const common = {
    /**
     * Azure Authentification (SSO)
     */
    msalConfig: {
        auth: {
            clientId: "217ef22a-ec11-4aec-afe2-8ad58f89f510",
            authority: "https://login.microsoftonline.com/5d471751-9675-428d-917b-70f44f9630b0",      
            redirectUri: window.location.hostname == 'wld.ext.net.nokia.com' ? (process.env.REACT_APP_EXTERNAL_MSAL_REDIRECT_URI
            ) : (window.location.hostname == 'xhaulwebnd.int.net.nokia.com' ? process.env.REACT_APP_INTERNAL_MSAL_REDIRECT_URI
                :
                (process.env.NODE_ENV == 'development' ? process.env.REACT_APP_MSAL_REDIRECT_URI_DEV :
                process.env.REACT_APP_MSAL_REDIRECT_URI_TEST)               
            )
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
        }
    },
    scopes: ["User.Read"],
    apiURI: window.location.hostname == 'wld.ext.net.nokia.com' ? (process.env.REACT_APP_EXTERNAL_WLD_API_URI
        ) : (window.location.hostname == 'xhaulwebnd.int.net.nokia.com' ? process.env.REACT_APP_INTERNAL_WLD_API_URI
            :
            (process.env.NODE_ENV == 'development' ? process.env.REACT_APP_WLD_API_URI_DEV :
            process.env.REACT_APP_WLD_API_URI_TEST)               
        )
    ,
    requestAccessEmail: process.env.REACT_APP_EMAIL_REQUEST_ACCESS_1 + "." + process.env.REACT_APP_EMAIL_REQUEST_ACCESS_2 + "@" + process.env.REACT_APP_EMAIL_REQUEST_ACCESS_DOMAIN, // process.env.REACT_APP_EMAIL_REQUEST_ACCESS,

    /**
     *              PREFIX
     * 
     *      prefix    |     URL     |    commentary
     *       login          /           user is not logged
     *       home           /           user is logged
     *    create_link   /link/create    page to create a link
     *       link        /link/:id      edit link page
     *       budget      /budget/:id    budget page
     *        news           *          pop-up to display latest update
    */
    sentences: {
        "home.popup.delete.link": "Your link configuration is deleted !",
        "home.popup.deletion_in_progress": "Deletion of your link...",
        "home.popup.deletion.problem": "A problem has occurred during the deletion",
        // Common sentences with create_link (/link/create) and link (/link/:id) page
        "create_link.popup.missing_parameters": "One or more parameters are missing !",
        "create_link.popup.saving": "Your link configuration is saved !",
        "create_link.popup.saving_in_progress": "Saving your link configuration",
        "create_link.popup.error": "A problem has occured during the saving !",
        "page.info.bom.warning": "Bill of Material is for informational purpose, please contact your sales representative for detailed configuration"
    }
};

const prod = {};

const dev = {};

export const CONFIG = process.env.NODE_ENV === 'development' ? {...dev, ...common} : {...prod, ...common};